/**
 * Auto-Restructure Cart
 * 
 * When an included item is removed, look for a matching 'a la carte' item in cart
 * and shift it into it's place.
 */

const storage = require('../util/flash-storage');
const Cart = require('./modules/Cart');
// const ProductItem = require('./modules/ProductItem');
const logger = require('../modules/Logger');
// const Panes = require('./modules/Panes');

const PublicForm = function(el, opts) {
    this.$el = el instanceof jQuery ? el : $(el);
    this.options = opts || {};
    this.cart = this.options.cart;
    // this.panes = this.options.panes;
    this.init();
};

PublicForm.prototype = {
    constructor: PublicForm,
    $el: undefined,
    $modal: undefined,
    // items: undefined,
    cart: undefined,
    // panes: undefined,
    options: undefined,
    typesConfig: undefined,
    accordionItemTemplate: undefined,
    // quantityTimeout: undefined,
    types: ['meat', 'potato', 'vegetable', 'rolls', 'pies', 'cakes', 'a-la-carte'],
    init: function() {
        var self = this;

        self.cart.on('add', function(evt) {
            self.renderCartItem(evt.item.type, evt.item.id);
        });

        self.$modal = $('#standard-modal');

        var typeConfigEl = document.querySelector('#product_types_config');
        self.typesConfig = typeConfigEl ? JSON.parse(typeConfigEl.innerHTML) : {};

        // self.items = {};
        // $('.pane-item').each(function() {
        //     var $this = $(this);
        //     self.items[$this.attr('data-id')] = new ProductItem($this[0], {});
        // });
        // console.log(self.items);

        var paneTabs = document.querySelectorAll('.tab-container');
        var panes = document.querySelectorAll('.pane');
        var panesChoice = Array.from(document.querySelectorAll('.pane-choice'));
        var paneScroll = document.querySelector('.pane-tabs');
        var itemSummary = document.querySelector('.item-summary');
        var summaryAmounts = document.querySelectorAll('.main-summary-amount');
        var includedAmounts = [];
        var makeChangesButton = document.querySelectorAll('.pane-button-1');
        var previousButton = document.querySelectorAll('.pane-button-2');
        var nextButton = document.querySelectorAll('.pane-button-3');
        for (i = 0; i < summaryAmounts.length; i++){
            var currentIncluded = $(summaryAmounts[i]).attr("data-include");
            includedAmounts.push(currentIncluded); 
         }
        for (i = 0; i < paneTabs.length; i++){
            self.paneSwitch(paneTabs, i, panes, previousButton, nextButton, panesChoice, makeChangesButton);
        }

        $('.included-container .item-quantity-submit-add').on('click', function() {
            var $item = $(this).closest('.pane-item');
            self.updateItemQuantityAmounts();
            self.plusIncluded($item);
            self.updateItemQuantityAmounts();
        });

        $('.included-container .item-quantity-submit-remove').on('click', function() {
            var $item = $(this).closest('.pane-item');
            self.updateItemQuantityAmounts();
            self.removeItem($item.attr('data-id'), true);
            self.toggleIncludedItemQuantity($item.closest('.pane.container'));
            self.updateItemQuantityAmounts();
        });

        $('.additional-container .item-quantity-submit-add').on('click', function() {
            var $item = $(this).closest('.pane-item');
            self.plusAdditional($item);
        });

        $('.additional-container .item-quantity-submit-remove').on('click', function() {
            var $item = $(this).closest('.pane-item');
            self.removeItem($item.attr('data-id'), false);
            self.toggleIncludedItemQuantity($item.closest('.pane.container'));
        });

        $('.qty-subtract').on('click', function() {
            self.updateItemQuantityAmounts();
            self.quantitySubtract($(this).closest('.pane-item'));
        });

        $('.qty-add').on('click', function() {
            self.updateItemQuantityAmounts();
            self.quantityAdd($(this).closest('.pane-item'));
        });

        var existingItemsConfigEl = document.querySelector('#existing_items_config');
        var existingItemsConfig = existingItemsConfigEl ? JSON.parse(existingItemsConfigEl.innerHTML) : null;
        var itemCache = storage.getItem('items', true);
        var existingCakesConfigEl = document.querySelector('#existing_cakes_config');
        var existingCakesConfig = existingCakesConfigEl ? JSON.parse(existingCakesConfigEl.innerHTML) : null;
        var cakesCache = storage.getItem('cakes', true);

        var addItem = function(item) {
            if (['included', 'additional'].indexOf(item.type) !== -1) {
                var $item = $(`.${item.type}-container[data-id="${item.id}"]`),
                    $container = $item.closest('.pane.container'),
                    idx = parseInt($container.attr('data-index'));
                if (item.type == 'additional' && [6, 7].indexOf(idx) === -1) {
                    idx = 3;
                }
                var $accordionParent = $(`.accordion-item[data-index="${idx}"]`);
                self.cart.addItem(item);
                if ($accordionParent.find('.accordion-body-product[data-id]').length) {
                    $accordionParent.find('.accordion-body-product-none').addClass('d-none');
                    if (!$accordionParent.find('.accordion-collapse').hasClass('show')) {
                        $accordionParent.find('.accordion-button').click();
                    }
                }
                self.updateAccordionQuantity();
            }
        };

        if (existingItemsConfig) {
            existingItemsConfig.forEach(function(item) {
                addItem(item);
            });
            self.toggleNextButton();
            self.toggleCheckoutButton();
            self.toggleMakeChangesBtn();
        }
        else if (itemCache) {
            itemCache.forEach(function(item) {
                addItem(item);
            });
            self.toggleNextButton();
            self.toggleCheckoutButton();
            self.toggleMakeChangesBtn();
        }
        else {
            // auto-add required-items

            if (false) {
                $('.pane-item[data-required-amount]').each(function() {
                    var $this = $(this);
                    console.log(132, $this.attr('data-required-amount'));
                    if ($this.attr('data-required-amount')) {
                        for (var i = 0; i < parseInt($this.attr('data-required-amount')); i++) {
                            $this.find('.item-quantity-submit-add').click();
                        }
                    }
                });
            }
        }

        if (existingCakesConfig || cakesCache) {
            $('input[name="decorated_cakes"]').val(JSON.stringify(existingCakesConfig ? existingCakesConfig : cakesCache));
        }

        // decorated cakes
        $('.decorated-cake-open-btn').on('click', function() {
            $(this).closest('.container').find('.row.d-none').removeClass('d-none');
            $(this).remove();
        });

        $('.decorated-cake-add-btn').on('click', function() {
            var $typeSelect = $('.decorated-cake-type-field'),
                $priceInput = $('.decorated-cake-price-field'),
                $cakeDataInput = $('input[name="decorated_cakes"]'),
                cakeData = JSON.parse($cakeDataInput.val()),
                formattedPrice = parseFloat($priceInput.val() ? $priceInput.val() : '0').toFixed(2);
            cakeData.push({
                type: $typeSelect.val(),
                price: formattedPrice
            });
            $cakeDataInput.val(JSON.stringify(cakeData));
            self.loadDecoratedCakes();
            self.updateCartTotals();
        });

        $('.decorated-cake-lineitems').on('click', '.decorated-cake-delete-btn', function(evt) {
            var $item = $(this).closest('.decorated-cake-lineitem'),
                $cakeDataInput = $('input[name="decorated_cakes"]'),
                cakeData = JSON.parse($cakeDataInput.val());
            cakeData.splice(parseInt($item.attr('data-index')), 1);
            $cakeDataInput.val(JSON.stringify(cakeData));
            self.loadDecoratedCakes();
            self.updateCartTotals();
        });

        if ($('input[name="decorated_cakes"]').length) {
            self.loadDecoratedCakes();
            self.updateCartTotals();
        }


        $('.review-order-button').on('click', function(evt) {
            evt.preventDefault();
            self.handleSubmitClick($(evt.currentTarget));
            return false;
        });
        window.addEventListener('scroll', function(){
            if (itemSummary) {
                if (this.window.scrollY > 90){
                    itemSummary.classList.add("item-summary-height");
                } else {
                    itemSummary.classList.remove("item-summary-height");
                }
            }
        });
        var itemSummaryToggle = document.querySelector('.item-summary-toggle');
        var itemSummaryBlur = document.querySelector('.item-summary-blur');
        if (itemSummaryToggle) {
            itemSummaryToggle.addEventListener("click", function(){
                    if (itemSummary) {
                        itemSummary.classList.add("show-summary");
                        itemSummaryBlur.classList.add("item-summary-blur-active");
                    }
            });
        }
        var itemSummaryExit = document.querySelector('.exit');
        if (itemSummaryExit) {
            itemSummaryExit.addEventListener("click", function(){
                itemSummary.classList.remove("show-summary");
                itemSummaryBlur.classList.remove("item-summary-blur-active");
                itemSummary.classList.add("hide-summary");
                setTimeout(() =>{
                    itemSummary.classList.remove("hide-summary");
                }, 2000)
            });
        }
        if (nextButton[0]){
            self.prevNextBtn(nextButton, 0, paneTabs, 7, 1, panes, previousButton, panesChoice, makeChangesButton, paneScroll);
            self.prevNextBtn(previousButton, 0, paneTabs, 0, -1, panes, nextButton, panesChoice, makeChangesButton, paneScroll);
        }
        if (nextButton[1]){
            self.prevNextBtn(nextButton, 1, paneTabs, 7, 1, panes, previousButton, panesChoice, makeChangesButton, paneScroll);
            self.prevNextBtn(previousButton, 1, paneTabs, 0, -1, panes, nextButton, panesChoice, makeChangesButton, paneScroll);
        }
        if (makeChangesButton[0]) {
            self.makeChangeButton(makeChangesButton, 0, paneTabs, panesChoice);
        }
        if (makeChangesButton[1]) {
            self.makeChangeButton(makeChangesButton, 1, paneTabs, panesChoice);
        }

        // Remove cart item
        document.querySelector('.main-summary').addEventListener('click', function(e) {
            var removeBtn = e.target.classList.contains('accordion-remove') ? e.target : e.target.closest('.accordion-remove');
            if (removeBtn) {
                logger.logButtonEvent($(removeBtn));
                var removeQuantity = removeBtn.classList.contains('accordion-remove-all') ? true : 1;
                self.removeFromCart(removeBtn, removeQuantity);
                self.restructureIncludedCart();
                self.toggleNextButton();
                self.toggleCheckoutButton();
                self.toggleMakeChangesBtn();
                self.includedQuantityLimits();
                self.updateItemAvailability();
                self.updateItemQuantityAmounts();
            }
        });

        // Reset storage when restarting order
        document.querySelector('.restart-order-button').addEventListener('click', function() {
            storage.removeItem('items');
            storage.removeItem('cakes');
            storage.wipeData();
            // remove checkout form cache
            localStorage.removeItem('checkoutForm');
        });

        // Scroll to top when clicking bottom buttons
        document.querySelector('.pane-buttons-bottom').addEventListener('click', function(evt) {
            var button = evt.target.classList.contains('pane-button') ? evt.target : evt.target.closest('.pane-button');
            if (button) {
                // needs a slight delay because pane change cause height to not register properly
                setTimeout(function() {
                    window.scrollTo(0, 0);
                }, 10);
            }
        });

        $('.pane-checkout-btn').on('click', function() {
            $('.review-order-button').click();
        });

        $('.notes-btn').on('click', function() { self.openNotesModal(); });

        self.toggleNextButton();
        self.toggleCheckoutButton();
        self.toggleMakeChangesBtn();
        self.updateCartTotals();
        self.includedQuantityLimits();
        self.updateItemQuantityAmounts();
    },
    restructureIncludedCart: function() {
        /**
         * 1) Cycle through included items
         *  - if requirements not met grab all additional in same category
         * 2) Update cart item to mark included
         */
        var self = this;
        // var requirements = self.formRequirements();
        var choiceValidation = self.validateChoices();
        var additionalItems = self.cart.filter({type: 'additional'});
        // console.log(2, additionalItems, choiceValidation);

        var findMatchingAdditional = function(additionalItems, category, quantity) {
            // match by category and quantity
            var match;
            Object.keys(additionalItems).forEach(function(prop) {
                var item = additionalItems[prop];
                // console.log('findMatchingAdditional:1', item.category === category && item.quantity == quantity);
                if (item.category === category && item.quantity == quantity) {
                    var $includedItem = $(`[data-key="${category}"] .pane-included .pane-item[data-id="${item.id}"]`);
                    var available = $includedItem.attr('data-available');
                    // console.log('findMatchingAdditional:2', $includedItem.length, available);
                    if ($includedItem.length && available !== 0) {
                        match = item;
                    }
                }
            });
            if (match) {
                return match;
            }
            // match by category
            Object.keys(additionalItems).forEach(function(prop) {
                var item = additionalItems[prop];
                // console.log('findMatchingAdditional:3', item.category === category);
                if (item.category === category) {
                    var $includedItem = $(`[data-key="${category}"] .pane-included .pane-item[data-id="${item.id}"]`);
                    var available = $includedItem.attr('data-available');
                    // console.log('findMatchingAdditional:4', $includedItem.length, available);
                    if ($includedItem.length && available !== 0) {
                        match = item;
                    }
                }
            });
            return match;
        };

        var runAgain = function() {
            var choiceValidation = self.validateChoices();
            var additionalItems = self.cart.filter({type: 'additional'});

            var again = false;
            Object.keys(choiceValidation).forEach(function(prop) {
                var validation = choiceValidation[prop];

                if (!validation.valid) {
                    Object.keys(additionalItems).forEach(function(addProp) {
                        var props = additionalItems[addProp];
                        var $includedItem = $(`[data-key="${prop}"] .pane-included .pane-item[data-id="${props.id}"]`);
                        var available = $includedItem.attr('data-available');
                        if ($includedItem.length && available !== 0) {
                            again = true;
                        }
                    });
                }
            });
            return again;
        };

        Object.keys(choiceValidation).forEach(function(prop) {
            var validation = choiceValidation[prop];

            if (!validation.valid) {
                // find any addition item in category
                var matched = findMatchingAdditional(additionalItems, prop, validation.remaining);

                if (matched) {
                    var uid = matched.uid();
                    var props = matched.export();
                    props.type = 'included';
                    // console.log('3:matched', prop, matched, uid, props);
                    self.removeItem(props.id, false);
                    var $includedItem = $(`[data-key="${prop}"] .pane-included .pane-item[data-id="${props.id}"]`);
                    var existingQuantity = parseInt($includedItem.find('.included-quantity-number').html());
                    var availableQuantity = $includedItem.attr('data-available') ? parseInt($includedItem.attr('data-available')) : null;

                    $includedItem.find('.included-quantity-number').html(1);

                    var count = validation.remaining;
                    if (availableQuantity !== null && availableQuantity > 0 && availableQuantity < count) {
                        count = availableQuantity;
                    }
                    if (count > props.quantity) {
                        count = props.quantity;
                    }
                    var originalCount = count;
                    while (count > 0) {
                        Object.keys(props.modifiers).forEach(function(modProp) {
                            var mod = props.modifiers[modProp];
                            $includedItem.find(`.modifier-select[name="${mod.key}"]`).val(mod.value);
                        });
                        self.plusIncluded($includedItem);
                        count--;
                    }

                    // add remaining additional
                    if (originalCount < props.quantity) {
                        var $additionalItem = $(`[data-key="${prop}"] .pane-additional .pane-item[data-id="${props.id}"]`);
                        var remainingCount = props.quantity - originalCount;
                        while (remainingCount > 0) {
                            self.plusAdditional($additionalItem);
                            remainingCount--;
                        }
                    }

                }
            }
        });

        if (runAgain()) {
            self.restructureIncludedCart();
        }
    },
    includedQuantityLimits: function() {
        var self = this,
            choiceValidation = self.validateChoices();
// console.log(choiceValidation);

        for (var key in choiceValidation) {
            var $container = $(`.pane.container[data-key="${key}"]`);
            if ($container.length) {
                $container.attr('data-remaining', choiceValidation[key].remaining);
                var $items = $container.find('.pane-included .pane-item');
                $items.each(function() {
                    var $this = $(this);
                    var currentQuantity = $this.find('.included-quantity-number').html();
                    if (currentQuantity > choiceValidation[key].remaining) {
                        currentQuantity = choiceValidation[key] > 0 ? choiceValidation[key] : 1;
                    }
                    $this.find('.included-quantity-number').html(currentQuantity);
                });
                self.toggleIncludedItemQuantity($container);
            }
        }
    },
    updateQuantityButtons: function() {
        var self = this,
            choiceValidation = self.validateChoices();
            
        for (var key in choiceValidation) {
            var $container = $(`.pane.container[data-key="${key}"]`);
            if ($container.length && choiceValidation[key].required) {
                var $items = $container.find('.pane-included .pane-item');
                var remaining = choiceValidation[key].remaining;
                // console.log([key, choiceValidation[key]]);
                $items.each(function() {
                    var $this = $(this);
                    
                });
            }
        }
    },
    openNotesModal: function() {
        var self = this,
            modal = bootstrap.Modal.getOrCreateInstance(self.$modal[0]);

        // modal setup
        if (!self.$modal.find('.modal-body textarea').length) {
            // textarea
            self.$modal.find('.modal-body').append('<textarea class="form-control">');
            self.$modal.find('.modal-body textarea').on('change', function() {
                $('[name="notes"]').val($(this).val());
            });
            self.$modal.find('.modal-body textarea').val($('[name="notes"]').val());

            // header
            self.$modal.find('.modal-header h5').html('Order Notes');

            // close button
            self.$modal.find('.modal-footer').append('<button type="button" class="btn btn-primary" data-bs-dismiss="modal">Save</button>');
        }

        modal.show();
    },
    loadDecoratedCakes: function() {
        var $cakeDataInput = $('input[name="decorated_cakes"]'),
            cakeData = JSON.parse($cakeDataInput.val()),
            $lineItemsContainer = $('.decorated-cake-lineitems');

        $lineItemsContainer.find('.decorated-cake-lineitem').remove();

        cakeData.forEach(function(cake, idx) {
            var formattedPrice = parseFloat(cake.price).toFixed(2)
            $lineItemsContainer.find('.col').append(
                $(`<div class="d-flex flex-row justify-content-between mt-1 text-secondary decorated-cake-lineitem" data-index="${idx}">
                    <div>Decorated Cake (${cake.type})</div>
                    <div>$${formattedPrice} <button class="btn btn-secondary btn-sm rounded-circle p-0 px-1 decorated-cake-delete-btn" type="button"><i class="bi bi-x-lg"></i></button></div>
                </div>`)
            );
        });
    },
    validateRequiredItems: function() {
        var self = this;
        var requiredItems = {};
        /**
         * Treat data-required-amount as a 'max' value.
         */
        $('.pane-choice').each(function() {
            var $choiceContainer = $(this);
            var incKey = $choiceContainer.attr('data-inc-key');
            var incRequirements = self.formRequirements()[incKey];
            var $container = $choiceContainer.closest('.pane.container');
            var dataRemaining = parseInt($container.attr('data-remaining'));
            // console.log([
            //     incKey, incRequirements, dataRemaining
            // ]);
            if (dataRemaining) {
                $choiceContainer.find('.pane-item[data-required-amount]').each(function() {
                    var $item = $(this);
                    var otherRequired = 0;
                    var otherSelected = 0;
                    $choiceContainer.find('.pane-item[data-required-amount]').each(function() {
                        var $this = $(this);
                        var id = $this.attr('data-id'),
                            required = $this.attr('data-required-amount') ? parseInt($this.attr('data-required-amount')) : 0,
                            currItems = self.cart.findById(id, 'included');
                        if (id != $item.attr('data-id')) {
                            if (incKey == 'inc_meats') {
                                // console.log(currItems, id, $item.attr('data-id'));
                            }
                            otherRequired += required;
                            otherSelected += Object.values(currItems).length;
                        }
                    });
                    if ($item.attr('data-required-amount')) {
                        // other required cannot exceed overall remaining
                        if (otherRequired > dataRemaining) {
                            otherRequired = dataRemaining;
                        }
                        var requiredAmount = parseInt($item.attr('data-required-amount'));
                        // console.log($item.attr('data-id'), otherRequired, otherSelected);
                        // console.log(requiredAmount, otherRequired, otherSelected, dataRemaining - (otherRequired - otherSelected));
                        requiredItems[$item.attr('data-id')] = dataRemaining - (otherRequired - otherSelected);
                        // console.log($item.attr('data-id'), dataRemaining - (otherRequired - otherSelected));
                    }
                });
            }
        });
        console.log('requiredItems', requiredItems);
        return requiredItems;
    },
    updateItemQuantityAmounts: function() {
        var self = this;
        // $('.pane-choice').each(function() {
        $('.pane-choice[data-inc-key="inc_meats"]').each(function() { // tmp to test only meats
            var $choiceContainer = $(this);
            var incKey = $choiceContainer.attr('data-inc-key');
            var incRequirements = self.formRequirements()[incKey];
            var $container = $choiceContainer.closest('.pane.container');
            var dataRemaining = parseInt($container.attr('data-remaining'));

            var items = {};
            $choiceContainer.find('.pane-item').each(function() {
                var $item = $(this);

                var otherRequired = 0,
                    otherSelected = 0;
                // other requirements
                $choiceContainer.find('.pane-item').each(function() {
                    var $this = $(this);
                    var id = $this.attr('data-id'),
                        required = $this.attr('data-required-amount') ? parseInt($this.attr('data-required-amount')) : 0,
                        currItems = self.cart.findById(id, 'included');
                    if ($this.attr('data-required-amount') && id != $item.attr('data-id')) {
                        otherRequired += required;
                        otherSelected += Object.values(currItems).length;
                    }
                });

                var itemData = {
                    $item: $item,
                    id: $item.attr('data-id'),
                    required: $item.attr('data-required-amount') ?? null,
                    max: $item.attr('data-max-amount') !== '' ? $item.attr('data-max-amount') : null,
                    cartItems: self.cart.findById($item.attr('data-id'), 'included')
                };

                itemData.available = itemData.max ? itemData.max - Object.values(itemData.cartItems).length : null;
                if (itemData.available === null) {
                    itemData.available = dataRemaining;
                }

                var maxPossiblity = dataRemaining - (otherRequired - otherSelected);
                itemData.maxPossiblity = maxPossiblity;
                // if (otherRequired - otherSelected > 0) {
                    // var maxPossiblity = otherRequired - otherSelected;
                    if (maxPossiblity <= itemData.available) {
                        itemData.available = maxPossiblity;
                    }
                // }

                if (itemData.required) {
                    itemData.satisfied = itemData.required - Object.values(itemData.cartItems).length === 0;
                }
                else {
                    itemData.satisfied = true;
                }

                $item.attr('data-available', itemData.available);
                // buttons state

                if (false) {
                    if (itemData.available === 0) {
                        $item.find('.item-quantity-submit-add').addClass('d-none');
                        $item.find('.item-quantity-submit-remove').removeClass('d-none');
                    }

                    var $quantityNumber = $item.find('.quantity-number');
                    var $includedAdd = $item.find('.included-add');
                    var $includedSubtract = $item.find('.included-subtract');
                    if (parseInt($quantityNumber.html()) > itemData.available) {
                        $quantityNumber.html(itemData.available);
                    }
                    if (parseInt($quantityNumber.html()) == itemData.available) {
                        $includedAdd.prop('disabled', true);
                    }
                    else {
                        $includedAdd.prop('disabled', true);
                    }

                    if (parseInt($quantityNumber.html()) == 1) {
                        $includedSubtract.prop('disabled', true);
                    }
                }

                items[`id_${itemData.id}`] = itemData;
                console.log('uiqa:2', itemData);
            });
        });
    },
    quantityAdd: function($item) {
        var self = this,
            limit = 99,
            $container = $item.closest('.pane.container'),
            category = $container.attr('data-category'),
            incKey = $container.find('.pane-choice').attr('data-inc-key'),
            requirements = self.formRequirements(),
            includedItem = $item.hasClass('included-container'),
            $quantityLabel = $item.find('.quantity-number'),
            quantity = parseInt($quantityLabel.html()),
            verifyForm = self.verifyForm();

        // need to verify item's required amount if applicable
        if (includedItem) {
            var items = self.cart.findById($item.attr('data-id'), 'included');
            var max = parseInt($container.attr('data-remaining'));
            var otherRequired = 0;
            var otherSelected = 0;
            $container.find('.pane-item').each(function() {
                var $this = $(this);
                var id = $this.attr('data-id'),
                    required = parseInt($this.attr('data-required-amount')),
                    currItems = self.cart.findById(id);
                if (id != $item.attr('data-id')) {
                    otherRequired += required;
                    otherSelected += Object.values(currItems).length;
                }
            });
            var remainingMax = max - (otherRequired - otherSelected);
            var requiredItems = self.validateRequiredItems();
            // console.log(requiredItems[$item.attr('data-id')] >= quantity + 1, quantity + 1);
            // apply validation logic in PHP
            if (
                quantity < requirements[incKey] - verifyForm[2][incKey] && (
                    requiredItems[$item.attr('data-id')] === undefined || requiredItems[$item.attr('data-id')] >= quantity + 1
                )) {
            // if (quantity < requirements[incKey] - verifyForm[2][incKey]) {
                if (quantity + 1 <= limit) {
                    quantity += 1;
                }
                else {
                    if (quantity == limit) {
                        $item.find('.quantity-number').removeClass('quantity-max');
                        $item.find('.quantity-number').addClass('quantity-max');
                        setTimeout(function() {
                            $item.find('.quantity-number').removeClass('quantity-max');
                        }, 501);
                    }
                }
            }

            if (quantity == requirements[incKey] - verifyForm[2][incKey]) {
                $item.find('.qty-add').prop('disabled', true);
            }

            self.updateItemAvailability();
        }
        else {
            if (quantity + 1 <= limit) {
                quantity += 1;
            }
            else {
                if (quantity == limit) {
                    $item.find('.quantity-number').removeClass('quantity-max');
                    $item.find('.quantity-number').addClass('quantity-max');
                    setTimeout(function() {
                        $item.find('.quantity-number').removeClass('quantity-max');
                    }, 501);
                }
            }
        }

        $quantityLabel.html(quantity);
        if (quantity > 1) {
            $item.find('.qty-subtract').prop('disabled', false);
        }
    },
    quantitySubtract: function($item) {
        var self = this,
            $quantityLabel = $item.find('.quantity-number'),
            quantity = parseInt($quantityLabel.html());

        quantity = quantity > 1 ? quantity - 1 : 1;

        $quantityLabel.html(quantity);

        $item.find('.qty-add').prop('disabled', false);
        if (quantity == 1) {
            $item.find('.qty-subtract').prop('disabled', true);
        }
    },
    toggleChoicePane: function($pane, state) {
        if (!state){
            $pane.removeClass("pane-choice-expand");
            $pane.addClass("pane-choice-collapse");
            setTimeout(() =>{
                $pane.addClass("hide-choice");
            }, 1000);
        } else {
            $pane.removeClass("pane-choice-expand");
            $pane.addClass("pane-choice-collapse");
            setTimeout(() =>{
                $pane.addClass("hide-choice");
            }, 1000);
        }
    },
    toggleIncludedItemQuantity: function($container) {
        var self = this,
            requirements = self.formRequirements(),
            $choiceContainer = $container.find('.pane-choice'),
            incKey = $choiceContainer.attr('data-inc-key');

        var verification = self.verifyForm();

        $choiceContainer.find('.pane-item').each(function() {
            var $item = $(this);
            if (requirements[incKey] == verification[2][incKey]) {
                $item.find('.item-quantity-changes').addClass('d-none');
                $item.find('.item-quantity-submit-add').addClass('d-none');
                if ($(`.accordion-body-product[data-id="${$item.attr('data-id')}"][data-inc="true"]`).length) {
                    $item.find('.item-quantity-submit-remove').removeClass('d-none');
                }
                self.toggleChoicePane($container.find('.pane-choice'), false);
                $('.pane-button-1').removeClass('pane-button-disable');
            }
            else {
                if (requirements[incKey] == 1) {
                    $item.find('.item-quantity-submit-add').removeClass('d-none');
                    $item.find('.item-quantity-submit-remove').addClass('d-none');
                }
                else {
                    $item.find('.item-quantity-changes').removeClass('d-none');
                    $item.find('.item-quantity-submit-add').removeClass('d-none');
                    $item.find('.item-quantity-submit-remove').addClass('d-none');
                }
            }
        });
    },
    updateItemAvailability: function() {
        return;
        var self = this;
        var requiredItems = self.validateRequiredItems();
        $('.pane-choice').each(function() {
            var $choiceContainer = $(this);
            var incKey = $choiceContainer.attr('data-inc-key');
            var incRequirements = self.formRequirements()[incKey];
            var $container = $choiceContainer.closest('.pane.container');
            var dataRemaining = parseInt($container.attr('data-remaining'));
            // console.log([
            //     incKey, incRequirements, dataRemaining
            // ]);
            if (dataRemaining) {
                $choiceContainer.find('.pane-item[data-required-amount]').each(function() {
                    var $this = $(this);
                    $this.attr('data-available', requiredItems[$this.attr('data-id')]);
                });
            }
        });

    },
    updateAccordionQuantity: function() {
        $('.accordion-item').each(function() {
            var $accordionItem = $(this);
            var quantityLabel = 0;
            $accordionItem.find('.accordion-body .accordion-body-product[data-id]').each(function() {
                var $this = $(this);
                quantityLabel += parseInt($this.find('.accordion-quantity').html());
            });
            $accordionItem.find('.main-summary-amount span').html(quantityLabel);
        });
    },
    plusIncluded: function($item) {
        var self = this,
            $container = $item.closest('.pane.container'),
            paneData = JSON.parse($item.find('.pane-item-data').html()),
            category = $container.attr('data-category'),
            key = $container.attr('data-key'),
            quantity = parseInt($item.find('.quantity-number').html()),
            $modifiers = $item.find('.modifier-select'),
            choiceValidation = self.validateChoices();

        // verify quantity doesn't exceed remaining amount
        if (quantity > choiceValidation[key].remaining) {
            quantity = choiceValidation[key].remaining;
        }

        var accordionData = {
            included: 'true',
            quantity: quantity,
            price: false,
            modifiers: [],
            modifiersKey: '--'
        };
        if ($modifiers.length) {
            var $option = $modifiers.find('option:selected');
            if ($option.attr('value') !== 'None') {
                accordionData.modifiers.push({
                    key: $modifiers.attr('name'),
                    value: $option.html(),
                    id: $option.attr('data-id'),
                    price: $option.attr('data-price')
                })
            }
        }

        // generate modifier 'key' for easier matching
        var modkey = [];
        accordionData.modifiers.forEach(function(item) {
            modkey.push(item.id);
        });
        modkey = '-' + modkey.join('-') + '-';
        accordionData.modifiersKey = modkey;

        self.cart.addItem({
            type: 'included',
            id: paneData.id,
            name: paneData.name,
            quantity: quantity,
            modkey: modkey,
            modifiers: accordionData.modifiers,
            price: parseFloat($item.attr('data-price')),
            upcharge: parseFloat($item.attr('data-upcharge')),
            category: paneData.category
        });

        // update accordion quantity label
        self.updateAccordionQuantity();

        self.toggleOpenAccordionItem($container.attr('data-index'));
        self.toggleIncludedItemQuantity($container);
        self.updateCartTotals();
        self.toggleNextButton();
        self.toggleCheckoutButton();
        self.toggleMakeChangesBtn();
        self.includedQuantityLimits();
        self.updateItemAvailability();

        // reset quantity
        $item.find('.quantity-number').html(1);

        // scroll back to top
        window.scrollTo(0, 0);
    },
    plusAdditional: function($item) {

        var self = this,
            $container = $item.closest('.pane.container'),
            paneData = JSON.parse($item.find('.pane-item-data').html()),
            quantity = parseInt($item.find('.quantity-number').html()),
            $modifiers = $item.find('.modifier-select');

        var accordionData = {
            included: 'false',
            quantity: quantity,
            modifiers: [],
            modifiersKey: '--',
            price: $item.attr('data-price')
        };
        if ($modifiers.length) {
            var $option = $modifiers.find('option:selected');
            if ($option.attr('value') !== 'None') {
                accordionData.modifiers.push({
                    key: $modifiers.attr('name'),
                    value: $option.html(),
                    id: $option.attr('data-id'),
                    price: $option.attr('data-price')
                    // quantity: 1
                })
            }
        }

        // generate modifier 'key' for easier matching
        var modkey = [];
        accordionData.modifiers.forEach(function(item) {
            modkey.push(item.id);
        });
        modkey = '-' + modkey.join('-') + '-';
        accordionData.modifiersKey = modkey;

        self.cart.addItem({
            type: 'additional',
            id: paneData.id,
            name: paneData.name,
            quantity: quantity,
            modkey: modkey,
            modifiers: accordionData.modifiers,
            price: parseFloat($item.attr('data-price')),
            category: paneData.category
        });

        // update accordion quantity label
        self.updateAccordionQuantity();

        if (['6', '7'].indexOf($container.attr('data-index')) !== -1) {
            self.toggleOpenAccordionItem($container.attr('data-index'));
        }
        else {
            self.toggleOpenAccordionItem(3);
        }

        // reset quantity
        $item.find('.quantity-number').html(1);

        self.updateCartTotals();

        // scroll back to top
        // window.scrollTo(0, 0);
    },
    removeItem: function(id, included) {
        /**
         * Restart button on pane items.
         */
        console.log(`.accordion-body-product[data-id="${id}"][data-inc="${included ? 'true' : 'false'}"]`);
        var self = this,
            $parent = $(`.accordion-body-product[data-id="${id}"][data-inc="${included ? 'true' : 'false'}"]`);
        
        // remove from cart
        self.cart.removeGroup($parent.attr('data-gid'));
        $parent.remove();
        self.updateCartTotals();
        self.updateAccordionQuantity();
        self.toggleNextButton();
        self.toggleCheckoutButton();
        self.includedQuantityLimits();
        self.updateItemAvailability();
    },
    renderCartItem: function(type, id) {
        var self = this,
            data = {},
            group = self.cart.group(type, id),
            config = self.typesConfig[group.category];

        data.cls = config.class;
        data.id = group.id;
        data.included = type == 'included' ? 'true' : 'false';
        data.groupId = `${type}_${id}`;
        data.name = group.name;
        data.image = config.image;
        data.items = group.items;
        data.price = type != 'included' ? group.price : false;
        data.quantity = group.quantity;

        if (!self.accordionItemTemplate) {
            self.accordionItemTemplate = _.template(document.querySelector('#summary_accordion_item_grouped').innerHTML.trim());
        }
        var rendered = self.accordionItemTemplate(data);

        // accordion item
        if (type == 'included' || ['6', '7'].indexOf($(`.pane.container[data-category="${config.class}"]`).attr('data-index')) !== -1) {
            var $accordionItem = $(`.accordion-item[data-category="${config.class}"]`);
        }
        else {
            var $accordionItem = $(`.accordion-item[data-category="a-la-carte"]`);
        }

        var $rendered = $(rendered);
        var $existing = $accordionItem.find('.accordion-body').find(`> [data-id="${data.id}"]`);
        if ($existing.length) {
            $rendered.insertBefore($existing);
            $existing.remove();
        }
        else {
            $accordionItem.find('.accordion-body').append($rendered);
        }

        self.includedQuantityLimits();

        return $rendered;
    },

    toggleOpenAccordionItem: function(i) {
        $(`.accordion-item[data-index="${i}"] .accordion-button.collapsed`).click();
    },
    validateChoices: function(pane) {
        var self = this,
            requirements = $('form').data('requirements'),
            $panes = $('.pane.container'),
            verifyForm = self.verifyForm();

        var paneChecks = {};
        $panes.each(function() {
            var $pane = $(this),
                key = $pane.attr('data-key'),
                incKey = self.typesConfig[key].inc;

            if (requirements[incKey] && requirements[incKey] > 0) {
                var remaining = requirements[incKey] - verifyForm[2][incKey];
                paneChecks[key] = { valid: remaining == 0, remaining: remaining, required: requirements[incKey] };
            }
            else {
                paneChecks[key] = { valid: true, remaining: 0, required: 0 };
            }
        });

        return paneChecks;
    },
    toggleNextButton: function() {
        var self = this,
            $active = $('.pane.container.active'),
            $nextBtn = $('.pane-button-3'),
            key = $active.attr('data-key'),
            choiceValidation = self.validateChoices();

        if ($active.length) {
            if (choiceValidation[key].valid) {
                // next button
                $nextBtn.removeClass('pane-button-disable');
            }
            else {
                // next button
                $nextBtn.addClass('pane-button-disable');
            }
        }
    },
    toggleCheckoutButton: function() {
        var self = this,
            tabs = document.querySelectorAll('.tab-container'),
            $checkoutBtn = $('.pane-checkout-btn'),
            $nextBtn = $('.pane-button-3');
        if (tabs[tabs.length - 1].classList.contains('active-tab')) {
            $nextBtn.addClass('d-none');
            if (self.verifyForm()[0]) {
                $checkoutBtn.addClass('active');
            }
            else {
                $checkoutBtn.removeClass('active');
            }
        }
        else {
            $checkoutBtn.removeClass('active');
            $nextBtn.removeClass('d-none');
        }
    },
    toggleMakeChangesBtn: function() {
        var self = this,
            $active = $('.pane.container.active'),
            $paneChoice = $active.find('.pane-choice'),
            key = $active.attr('data-key'),
            choiceValidation = self.validateChoices();

        if (choiceValidation[key].valid) {
            $('.pane-button-1').removeClass('pane-button-disable');
            $paneChoice.addClass("hide-choice");
            $paneChoice.addClass("pane-choice-collapse");
            $paneChoice.removeClass("pane-choice-expand");
        }
        else {
            $('.pane-button-1').addClass('pane-button-disable');
            $paneChoice.removeClass("hide-choice");
            $paneChoice.removeClass("pane-choice-collapse");
            $paneChoice.addClass("pane-choice-expand");
        }
    },
    removeFromCart: function(removeBtn, quantity) {
        var self = this,
            $button = $(removeBtn),
            $parent = $(removeBtn.closest('.accordion-body-product')),
            $accordionItem = $parent.closest('.accordion-item'),
            quantity = typeof quantity === 'undefined' ? 1 : quantity;

        var itemKey = $parent.attr('data-gid');
        if ($button.closest('.product-modifiers[data-modkey]').attr('data-modkey')) {
            // is modifier
            itemKey += '_' + $button.closest('.product-modifiers').attr('data-modkey');
        }
        else {
            itemKey += '_--';
        }

        var item = self.cart.findItem(itemKey);
        if (item && item.quantity) {
            item.quantity = quantity === true ? 0 : item.quantity - quantity;
        }

        var rerender = true;
        if (item.quantity < 1) {
            self.cart.removeItem(itemKey);
            // check for other items
            if ($parent.find('.product-modifiers-group .product-modifiers').length == 1) {
                $parent.remove();
                rerender = false;
            }
            else {
                $parent.find(
                    `.product-modifiers-group .product-modifiers[data-modkey="${$button.closest('.product-modifiers').attr('data-modkey')}"]`
                ).remove();
            }
        }
        if (rerender) {
            var [itemType, itemId] = $parent.attr('data-gid').split('_');
            self.renderCartItem(itemType, itemId);
        }

        // if (quantity === true) {
        //     // self.cart.removeGroup($parent.attr('data-gid'));
        //     var item = self.cart.findItem(itemKey);
        //     if (item && item.quantity) {
        //         item.quantity -= quantity;
        //     }
        //     // $parent.remove();
        // }
        // else {
        //     var item = self.cart.findItem(itemKey);
        //     if (item && item.quantity) {
        //         item.quantity -= quantity;
        //     }
        //     if (item.quantity < 1) {
        //         self.cart.removeItem(itemKey);
        //         // check for other items
        //         if ($parent.find('.product-modifiers-group .product-modifiers').length == 1) {
        //             $parent.remove();
        //         }
        //         else {
        //             $parent.find(
        //                 `.product-modifiers-group .product-modifiers[data-modkey="${$button.closest('.product-modifiers').attr('data-modkey')}"]`
        //             ).remove();
        //         }
        //     }
        //     else {
        //         var [itemType, itemId] = $parent.attr('data-gid').split('_');
        //         self.renderCartItem(itemType, itemId);
        //     }
        // }
// return;
        // remove from cart
        // self.cart.removeGroup($parent.attr('data-gid'));
        // $parent.remove();

        self.updateCartTotals();
        self.updateAccordionQuantity();

        // select current category pane
        // if in a-la-carte accordion item, but not a-la-carte it indicated its additional
        var isAdditional = $parent.attr('data-category') !== $accordionItem.attr('data-category');
        $(`.tab-container.tab-${$parent.attr('data-category')}`).click();

        self.toggleNextButton();
        self.toggleCheckoutButton();
        self.toggleMakeChangesBtn();
        $('.pane.container').each(function() {
            self.toggleIncludedItemQuantity($(this));
        });

        if (isAdditional) {
            // when choice is not expanded, try delay
            setTimeout(function() {
                $('html, body').scrollTop($('.pane.container.active').find('.pane-additional').offset().top - 150);
            }, 250);
        }
    },
    paneSwitch: function(array, number, panes, previousButton, nextButton, panesChoice, changesButton){
        var self = this;
        if (!(array[number].classList.contains("disable-tab"))){
            array[number].addEventListener("click", function(){
                array[number].classList.add("active-tab");
                panes[number].classList.add("active");
                for (var x = 0; x < array.length; x++){
                    if (x !== number){
                        array[x].classList.remove("active-tab");
                        panes[x].classList.remove("active");
                    }
                }
                if (number == 0){
                    previousButton[0].classList.add("pane-button-disable");
                    previousButton[1].classList.add("pane-button-disable");
                } else {
                    previousButton[0].classList.remove("pane-button-disable");
                    previousButton[1].classList.remove("pane-button-disable");
                }
                if (number == 6){
                    nextButton[0].classList.add("pane-button-disable");
                    nextButton[1].classList.add("pane-button-disable");
                } else {
                    nextButton[0].classList.remove("pane-button-disable");
                    nextButton[1].classList.remove("pane-button-disable");
                }
                var paneNumber = number;
                if (number > 3){
                    paneNumber = number - 1;
                }
                if (panesChoice[paneNumber] != null){
                    if (number !== 3){
                        if (panesChoice[paneNumber].classList.contains("hide-choice")){
                            changesButton[0].classList.remove("pane-button-disable");
                            changesButton[1].classList.remove("pane-button-disable");
                        } else {
                            changesButton[0].classList.add("pane-button-disable");
                            changesButton[1].classList.add("pane-button-disable");
                        }
                    } else{
                        changesButton[0].classList.add("pane-button-disable");
                        changesButton[1].classList.add("pane-button-disable");
                    }
                } else {
                    changesButton[0].classList.add("pane-button-disable");
                    changesButton[1].classList.add("pane-button-disable");
                }
                self.toggleNextButton();
                self.toggleCheckoutButton();
                self.toggleMakeChangesBtn();
            })
        }
    },
    findNextAvailableTab: function(tabs, currentIndex, direction) {
        var nextTab, checkIndex;
        var iteration = 0;
        do {
            iteration++;
            checkIndex = currentIndex + (direction * iteration);
            if (!tabs[checkIndex].classList.contains('disable-tab')) {
                nextTab = tabs[checkIndex];
            }
        } while (typeof nextTab === 'undefined' && (checkIndex > 0 && checkIndex < tabs.length - 1));
        if (typeof nextTab === 'undefined') {
            checkIndex = null;
        }
        return { direction: nextTab ? direction * iteration : null, tab: nextTab, index: checkIndex };
    },
    prevNextBtn: function(button, buttonNumber, paneTabs, number, number2, panes, button2, choices, makeChangeButton, paneScroll){
        var self = this;
        button[buttonNumber].addEventListener("click", function(){
            var secondNumber = number2;
            for (i = 0; i< paneTabs.length; i++){
                if (paneTabs[i].classList.contains("active-tab")){
                    var active = i;
                }
            }
            if ((active + secondNumber) > -1 && (active + secondNumber) <= paneTabs.length){
                if (paneTabs[active + secondNumber].classList.contains("disable-tab")) {
                    // next tab is disabled, need to find next available tab.
                    var nextTabResults = self.findNextAvailableTab(paneTabs, active, secondNumber);
                    if (nextTabResults.direction !== null) {
                        secondNumber = nextTabResults.direction;
                    }
                }
                if (!(paneTabs[active + secondNumber].classList.contains("disable-tab"))){
                    if (active !== number){
                        paneTabs[active].classList.remove("active-tab");
                        paneTabs[active + secondNumber].classList.add("active-tab");
                        panes[active].classList.remove("active");
                        panes[active + secondNumber].classList.add("active");
                        button2[0].classList.remove("pane-button-disable");
                        button2[1].classList.remove("pane-button-disable");
                    }
                }
                var paneNumber = active + secondNumber;
                if (paneNumber > 3){
                    paneNumber = (active + secondNumber) -1;
                }
                if (choices[paneNumber] != null){
                    if ((active + secondNumber) !== 3){
                        if (choices[paneNumber].classList.contains("hide-choice")){
                            makeChangeButton[0].classList.remove("pane-button-disable");
                            makeChangeButton[1].classList.remove("pane-button-disable");
                        } else {
                            makeChangeButton[0].classList.add("pane-button-disable");
                            makeChangeButton[1].classList.add("pane-button-disable");
                        }
                    } else {
                        makeChangeButton[0].classList.add("pane-button-disable");
                        makeChangeButton[1].classList.add("pane-button-disable");
                    }
                } else {
                    makeChangeButton[0].classList.add("pane-button-disable");
                    makeChangeButton[1].classList.add("pane-button-disable");
                }
            }
            if ((active + secondNumber) == number || active == number){
                button[0].classList.add("pane-button-disable");
                button[1].classList.add("pane-button-disable");
            } else {
                button[0].classList.remove("pane-button-disable");
                button[1].classList.remove("pane-button-disable");
            }
            if (secondNumber == -1){
                if (active + secondNumber + secondNumber > -1){
                    if (paneTabs[active + secondNumber + secondNumber].classList.contains("disable-tab")){
                        button.classList.add("pane-button-disable");
                    }
                }
            }
            var tabWidth = paneTabs[0].offsetWidth;
            for (i = 0; i< paneTabs.length; i++){
                if (paneTabs[i].classList.contains("active-tab")){
                    var active = i;
                }
            }
            activeTab = paneTabs[active];
            scrollAmount = tabWidth * active;
            if (window.innerWidth > 700){
                paneScroll.scrollTo({
                    top: 0,
                    left: scrollAmount,
                    behavior: "smooth",
                });
            } else {
                paneScroll.scrollTo({
                    top: 0,
                    left: scrollAmount - (50 * active),
                    behavior: "smooth",
                });
            }
            self.toggleNextButton();
            self.toggleCheckoutButton();
            self.toggleMakeChangesBtn();
        })
        
    },
    makeChangeButton: function(button, buttonNumber, paneTabs, panesChoice) {
        var self = this;
        button[buttonNumber].addEventListener("click", function(){
            for (i = 0; i < paneTabs.length; i++){
                if (paneTabs[i].classList.contains("active-tab")){
                    var active = i;
                }
            }
            var paneNumber = active;
            if (active > 3){
                paneNumber = active - 1;
            }
            if (panesChoice[paneNumber] != null){
                if (active !== 3){
                    if (panesChoice[paneNumber].classList.contains("hide-choice")){
                        panesChoice[paneNumber].classList.remove("hide-choice");
                        panesChoice[paneNumber].classList.remove("pane-choice-collapse");
                        panesChoice[paneNumber].classList.add("pane-choice-expand");
                    }
                }
            }
            button[0].classList.add("pane-button-disable");
            button[1].classList.add("pane-button-disable");
            self.toggleCheckoutButton();
        });
    },
    calculateCartTotals: function() {
        if (!document.querySelector('form')) {
            return false;
        }
        var self = this,
            items = self.cart.exportArray(),
            baseTotal = parseFloat(document.querySelector('form').getAttribute('data-price')),
            upchargeTotal = 0.0,
            alacarteTotal = 0.0,
            orderTotal = 0.0,
            decoratedCakeTotal = 0.0;

        items.forEach(function(item) {
            var modifierTotal = item.modifiers.reduce((sum, modifier) => sum += parseFloat(modifier.price) * item.quantity, 0.0);
            item.type == 'included'
                ? upchargeTotal += (item.upcharge * item.quantity) + modifierTotal
                : alacarteTotal += (item.price * item.quantity) + modifierTotal
            ;
        });

        var $cakeDataInput = $('input[name="decorated_cakes"]'),
            cakeData = $cakeDataInput.length ? JSON.parse($cakeDataInput.val()) : [];
        
        cakeData.forEach(function(cake) {
            decoratedCakeTotal += parseFloat(cake.price);
        });

        orderTotal = baseTotal + alacarteTotal + upchargeTotal;

        return {
            baseTotal: baseTotal,
            alacarteTotal: alacarteTotal,
            upchargeTotal: upchargeTotal,
            decoratedCakeTotal: decoratedCakeTotal,
            orderTotal: orderTotal
        }
    },
    updateCartTotals: function() {
        var self = this,
            totals = self.calculateCartTotals(),
            alacarteTotal = document.querySelector("#a-la-carte-total-amount"),
            upchargeTotal = document.querySelector("#upcharge-total-amount"),
            orderTotal = document.querySelector("#order-total-amount");
        if (!totals) {
            return;
        }
        alacarteTotal.innerHTML = totals.alacarteTotal.toFixed(2);
        upchargeTotal.innerHTML = totals.upchargeTotal.toFixed(2);
        orderTotal.innerHTML = (totals.orderTotal + totals.decoratedCakeTotal).toFixed(2);

        // verify form and enable checkout button
        if (self.verifyForm()[0]) {
            document.querySelector('.order-review-warning').classList.remove('visible');
            document.querySelector('.review-order-button').classList.remove('disabled');
        }
        else {
            document.querySelector('.review-order-button').classList.add('disabled');
        }

        var base = {};
        base.dinner = {
            'id': $('form').data('id')
        };
        base.cart = self.cart.exportArray();
        var $cakeDataInput = $('input[name="decorated_cakes"]');
        if ($cakeDataInput.length) {
            base.cakes = JSON.parse($cakeDataInput.val());
        }
        logger.baseData = { order: base };
        // console.info('Cart totals updated.');
    },
    updateModifiers: function() {
        var self = this;

        document.querySelectorAll('.accordion-body-product.show-accordion-product').forEach(function(accordionItem) {
            var isAlacarte = accordionItem.classList.contains('accordion-body-product-a-la-carte');
            var itemClass = (isAlacarte ? '.additional-container' : '.included-container') + '[data-id="' + accordionItem.getAttribute('data-id') + '"]';
            var accordionItemModifiers = accordionItem.querySelector('.product-modifiers');

            if (accordionItemModifiers) {
                accordionItemModifiers.innerHTML = '';
            }

            var item = document.querySelector(itemClass);
            if (!item) return;

            var modifiers = item.querySelectorAll('.item-modifiers select');
            if (!modifiers.length) return;

            modifiers.forEach(function(modifier) {
                var price = modifier.options[modifier.selectedIndex];
                    price = price.getAttribute('data-price') && price.getAttribute('data-price') !== '0.00' ? price.getAttribute('data-price') : false,
                    priceLabel = price ? ' (+' + price + ')' : '';
                accordionItemModifiers.innerHTML = accordionItemModifiers.innerHTML + '<div>' + modifier.value + priceLabel + '</div>';
            });
        });
    },
    getCartItemModifiers: function($accordionItem) {
        var $productModifiers = $accordionItem.find('.product-modifiers'),
            modifiers = {};
        $productModifiers.each(function() {
            var $modifierGroup = $(this);
            var group = [];
            $modifierGroup.find('.product-modifier').each(function() {
                var $modifier = $(this);
                group.push({
                    id: $modifier.attr('data-id'),
                    price: $modifier.attr('data-price'),
                    key: $modifier.attr('data-key'),
                    value: $modifier.find('.product-modifier-name').html(),
                    quantity: parseFloat($modifier.find('.product-modifier-quantity').attr('data-quantity'))
                });
            });
            modifiers[$modifierGroup.attr('data-modkey')] = group;
        });
        return modifiers;
    },
    formData: function() {
        var self = this,
            $form = $('form'),
            order = {
                items: [
                    {
                        'id': $form.data('id'),
                        'quantity': 1,
                        'type': 'dinner'
                    }
                ],
                dinnerId: $form.data('id'),
                included: {},
                additional: {},
                totals: self.calculateCartTotals()
            };

        order.items = order.items.concat(self.cart.exportArray());

        return order;
    },
    verifyForm: function() {
        var self = this,
            map = {inc_meats: 'meats', inc_potatoes: 'potatoes', inc_vegetables: 'vegetables', inc_rolls: 'rolls', inc_pies: 'pies', inc_cakes: 'cakes'},
            isValid = true,
            invalid = {},
            order = self.formData(),
            counts = {},
            requirements = self.formRequirements();
        for (var key in requirements) {

            var items = order.items,
                quantity = 0;

            counts[key] = 0;

            items.forEach(function(item) {
                if (item.type == 'included' && item.category == map[key]) {
                    quantity += item.quantity;
                    counts[key] += item.quantity;
                }
            });

            if (quantity < requirements[key]) {
                isValid = false;
                invalid[map[key]] = requirements[key];
            }
        }
        return [isValid, invalid, counts];
    },
    handleSubmitClick: function() {
        var self = this,
            $form = $('form'),
            verification = self.verifyForm(),
            data = self.formData(),
            totals = self.calculateCartTotals();
        $('[name="total"]').val(totals.orderTotal);
        $('[name="additional_total"]').val(totals.alacarteTotal);
        $('[name="items"]').val(JSON.stringify(data.items));
        if (verification[0]) {
            storage.setItem('items', data.items);
            var $cakeDataInput = $('input[name="decorated_cakes"]');
            if ($cakeDataInput.length) {
                storage.setItem('cakes', JSON.parse($cakeDataInput.val()));
            }
            $form.submit();
        }
        else {
            document.querySelector('.order-review-warning').classList.add('visible');
        }
    },
    formRequirements: function() {
        return PublicForm.getFormRequirements();
    }
};

PublicForm.getFormRequirements = function() {
    var fallbackRequirements = {inc_meats: 0, inc_potatoes: 0, inc_vegetables: 0, inc_rolls: 0, inc_pies: 0, inc_cakes: 0},
        requirements = $('form').attr('data-requirements');
    return requirements = requirements ? JSON.parse(requirements) : fallbackRequirements;
};

window.addEventListener('load', function() {
    var publicForm = document.querySelector('.public-form');
    var tmeals = document.querySelector('.t-meals');
    var checkout = document.querySelector('.checkout-container');

    if (publicForm && !tmeals && !checkout) {
        var cart = new Cart(PublicForm.getFormRequirements());
        // var panes = new Panes(document.querySelector('.panes'));
        // var mod = new PublicForm(publicForm, { cart: cart, panes: panes });
        var mod = new PublicForm(publicForm, { cart: cart });
        window.cart = cart;
        // window.panes = panes;
        window.form = mod;
    }
});
